"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = exports.TextColumnConfigSchema = exports.PercentageColumnConfigSchema = exports.DateColumnConfigSchema = exports.CurrencyColumnConfigSchema = void 0;
const _imports_1 = require("../_imports");
/**
 * *** SHARED COLUMN CONFIG ***
 * Shared column configuration schemas used by both Inputs (fileInsertAthenaQueries)
 * and Outputs.Docx (file insertion configs)
 */
exports.CurrencyColumnConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('currency'),
    format: _imports_1.z.enum(_imports_1.Utils.CurrencyFormatIterable),
    name: _imports_1.z.string(),
    propertyName: _imports_1.z.string(),
    order: _imports_1.z.number(),
});
exports.DateColumnConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('date'),
    format: _imports_1.z.string(),
    name: _imports_1.z.string(),
    propertyName: _imports_1.z.string(),
    order: _imports_1.z.number(),
});
exports.PercentageColumnConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('percentage'),
    format: _imports_1.z.enum(_imports_1.Utils.PercentageFormatIterable),
    name: _imports_1.z.string(),
    propertyName: _imports_1.z.string(),
    order: _imports_1.z.number(),
});
exports.TextColumnConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('text'),
    format: _imports_1.z.enum(_imports_1.Utils.TextFormatIterable),
    name: _imports_1.z.string(),
    propertyName: _imports_1.z.string(),
    order: _imports_1.z.number(),
});
exports.Schema = _imports_1.z.discriminatedUnion('type', [
    exports.CurrencyColumnConfigSchema,
    exports.DateColumnConfigSchema,
    exports.PercentageColumnConfigSchema,
    exports.TextColumnConfigSchema,
]);
//# sourceMappingURL=ColumnConfig.js.map